// extracted by mini-css-extract-plugin
export var closeBtn = "Modal-module--closeBtn--eab95";
export var formControl = "Modal-module--form-control--4cb22";
export var modal = "Modal-module--modal--2c201";
export var modalContainer = "Modal-module--modal-container--f0ed8";